module.exports = __webpack_public_path__ + "static/img/photo.4bfe217.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/landing/photo.png
// module id = oWDD
// module chunks = 1